import { AlertTriangleIcon } from "lucide-react";

export default function InvalidTokenMsg() {
    return (
        <div className="rounded-lg border border-amber-200 bg-amber-50 p-4">
            <div className="flex items-start gap-3">
                <AlertTriangleIcon className="text-primary" />
                <div>
                    <h3 className="text-sm font-medium text-amber-800">
                        Link Already Used
                    </h3>
                    <p className="mt-1 text-sm text-amber-700">
                        This onboard link has expired and cannot be used. Please
                        request a new link from the team to register.
                    </p>
                </div>
            </div>
        </div>
    );
}
